import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

export const MergeExpiredPanel = () => {
  return (
    <MultilineMessageBox variant="error" icon={<MessageBoxIcon size={"md"} variant="error" />}>
      <BodySM className="text-error-text">
        This veSCALE NFT has expired. You cannot merge an expired NFT. Please reset the NFT first if you want to manage
        it.
      </BodySM>
    </MultilineMessageBox>
  )
}
